// @flow
// @jsx h
import formStyles from "./FormInput.scss";
import errorStyles from "./InputError.scss";

import { h, Component } from 'preact';

import { en, fr, de, nl, it, es, ca } from "./translations";

import Loading from "elc-loading";



export class CommunesAjax extends Component {
    state = {
        loading: false,
        error: null,
        data: null
    };

    componentDidMount() {
        this.loadData(this.props.query, this.props.locality);
    }

    componentDidUpdate(nextProps) {
          if (
            nextProps.query !== this.props.query 
        ) {
            this.loadData(nextProps.query);
        }
    }

  // jsonp = (ref, q) => {
  //   return new Promise((resolve, reject) => {
  //     const callbackName = 'cb' + Math.trunc(Math.random() * 10e10);
  //     const script = document.createElement('script');
  //     script.src = 'https://etape-rest.for-system.com/index.aspx?ref='+ref+'&q='+q+'&callback=' + callbackName;

  //     window[callbackName] = (o) => {
  //       resolve(o);
  //       delete window[callbackName];
  //       document.head.removeChild(script);
  //     };

  //     document.head.append(script);    
  //   })
  // }

  jsonp = (url) => {
    return new Promise((resolve, reject) => {
        const callbackName = "jsonp_cb_" + Math.random().toString(36).substr(2);

        window[callbackName] = (data) => {
            resolve(data);
            delete window[callbackName];
            script.remove();
        };

        const script = document.createElement("script");

        script.src = url + (url.includes("?") ? "&" : "?") + "callback=" + callbackName;
        script.onerror = () => {
            reject(new Error("JSONP error"));
            delete window[callbackName];
        };

        document.body.appendChild(script);
    });
}



loadData(query, locality = "") {    
    if (!query) {
        this.setState({ data: null, error: null });
        return;
    }
    query = query.toString().trim();

    if (!/^[0-9]{1,5}$/.test(query) || (query.length>1 && parseInt(query.substr(0,2).replace(/^0/,""))>95)) {
        this.setState({ error: "Code postal invalide", data: null });
        return;
    }
    
    else if(/^00/.test(query)) {
        this.setState({ data: [{cp:"00",nom:"ARMEES"}], error: null });
        return;
    } 

    else if(query.length > 4 && !(/^(750|690|130)/.test(query))) {
      query = query.substr(0, 4);
    }

    this.setState({ loading: true, error: null });

    const url = `https://etape-rest.for-system.com/index.aspx?ref=json-commune&q=${encodeURIComponent(query)}`;

    this.jsonp(url)
        .then(json => {

            if (json.statut === "ok") {
                // Cherche la commune correspondant à la locality 
                const selectedCommune = json.listeCommune.find(
                    c => c.nom.toUpperCase() === (locality || "").toUpperCase()
                );

                const selectedCp = selectedCommune ? selectedCommune.nom : "";
                this.setState({ data: json.listeCommune, loading: false });
                if(locality != "" && locality != null){
                    this.setState({ selectedCp });
                }
            } else {
                this.setState({ error: "Code postal Invalide", loading: false });
            }
        })
        .catch(err => {
            this.setState({ error: err.message, loading: false });
        });
}


    render({theme}, { loading, error, data }) {
        if (loading) return <div class={`${formStyles.input} ${formStyles.inputLoader}`}><Loading /></div>;
        if (error) return <div  class={`${formStyles.input} ${errorStyles.error}`}>{error}</div>;
        if (!data) return <div class={formStyles.input}>-</div>;

        return (
          <div
            class={
              theme && theme.selectWrapper
                ? theme.selectWrapper
                : formStyles.selectWrapper
            }
          >

          <select
            class={formStyles.select}
            value={this.state.selectedCp || ""} 
            onChange={(e) => {
                const index = e.target.selectedIndex - 1; // -1 pour la placeholder
                const commune = this.state.data[index];   // { cp, nom }

                if (commune) {
                // Mise à jour du state
                this.setState({ selectedCp: commune.nom });

                // Notification au parent
                if (this.props.onSelect) {
                    this.props.onSelect(commune);
                }
                }
            }}
          >
            <option value="">Votre ville</option>
            {data.map((c) => (
              <option value={c.nom}>
                {c.nom}
              </option>
            ))}
          </select>

          </div>
        );
    }
}
